module.exports = __webpack_public_path__ + "static/media/export.ceb0dc60.svg";